// extracted by mini-css-extract-plugin
module.exports = {"modal":"pm","error":"qm","disabled":"rm","fields":"sm","header":"tm","footer":"um"};